import { t } from '@lingui/macro'
import { Comparator } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'

type Props = {
  isEmpty?: boolean
}

type ReturnType = Record<string, Comparator[]>

export const getComparators = ({ isEmpty = true }: Props = {}): ReturnType => {
  return {
    text: [
      { label: t({ id: 'dataGrid.comparator.contains', message: 'Contains' }), value: 'like', icon: 'check' },
      { label: t({ id: 'dataGrid.comparator.notContains', message: 'Not contains' }), value: 'notLike', icon: 'false' },
      { label: t({ id: 'dataGrid.comparator.equals', message: 'Equals' }), value: 'eq', icon: 'equals' },
      { label: t({ id: 'dataGrid.comparator.notEquals', message: 'Not equal' }), value: 'neq', icon: 'notEqual' },
      { label: t({ id: 'dataGrid.comparator.startsWith', message: 'Starts with' }), value: 'startsWith', icon: 'startsWith' },
      { label: t({ id: 'dataGrid.comparator.endsWith', message: 'Ends with' }), value: 'endsWith', icon: 'endsWith' },
      ...(isEmpty
        ? [{ label: t({ id: 'dataGrid.comparator.isEmpty', message: 'Is empty' }), value: 'isEmpty', icon: 'notEqual' }]
        : []),
    ],
  }
}
